import React from 'react';
import { Star, Users, ShieldCheck, Headphones, Award, Plane } from 'lucide-react';
import { TRUST_BADGES } from '../../mock';

const ICONS = { Star, Users, ShieldCheck, Headphones, Award, Plane };

export function TrustStrip() {
  return (
    <section className="relative -mt-12 z-10 px-6">
      <div className="max-w-6xl mx-auto bg-white rounded-2xl shadow-premium grid grid-cols-2 md:grid-cols-4 gap-0 overflow-hidden border border-brand-greyDark">
        {TRUST_BADGES.map((b, i) => {
          const Icon = ICONS[b.icon] || Star;
          return (
            <div key={i} className={`p-5 lg:p-6 flex items-center gap-4 ${i < TRUST_BADGES.length - 1 ? 'md:border-r border-brand-greyDark' : ''} ${i < TRUST_BADGES.length - 2 ? 'border-b md:border-b-0' : ''}`}>
              <div className="w-11 h-11 rounded-xl bg-brand-orange/10 flex items-center justify-center shrink-0">
                <Icon size={20} className="text-brand-orange" />
              </div>
              <div>
                <div className="font-poppins font-semibold text-brand-blue text-[14px] leading-tight">{b.label}</div>
                <div className="text-[12px] text-brand-blue/60 mt-0.5">{b.value}</div>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}

export default TrustStrip;
